import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Avatar from '@mui/material/Avatar';
import { useAuth } from "../../hooks/AuthProvider";
import { getHeaders } from '../../utils/apis';
import * as Icon from 'react-bootstrap-icons';
import './MainNavbar.css';
import { web_timeout } from '../../global';

function url_domain(data) {
    var a = document.createElement('a');
    a.href = data;
    return a.hostname;
}

const MainNavbar = () => {
    const [sysMenu, setSysMenu] = useState([]);
    const auth = useAuth();
    const [site, setSite] = useState('shirt.vn');

    let hostname = url_domain(window.location.href);


    useEffect(() => {


        //console.debug("User", auth.user);

        if (url_domain(window.location.href) === 'customshirt.vn') {
            setSite('customshirt.vn');
            document.title = 'Welcome to customshirt.vn';
        }

        if (auth.user) {
            let seconds = (Date.now() - auth.user.timestamp) / 1000;
            if (seconds > web_timeout) {
                auth.logOut();
            } else {
                setSysMenu(auth.user.sysMenu);
            }
        }



    }, []);

    return (<>

        <Navbar expand="lg" style={{ marginBottom: "0px" }} >
            <Container>

                {/* <Navbar.Brand href="/"><strong>SHIRT.VN</strong></Navbar.Brand> */}

                {auth.user ? <>

                    {
                        auth.user.big_logo ?
                            <Navbar.Brand href="/dashboard"><img src={auth.user.big_logo} alt={site} style={{ width: "100px" }} /></Navbar.Brand>
                            :
                            <>
                                <Navbar.Brand href="/dashboard"><h2><strong>{auth.user.tailorshop_name}</strong></h2></Navbar.Brand>
                            </>
                    }
                </>
                    : <>
                        {(site === 'customshirt.vn') && <>
                            <Navbar.Brand href="/login"><h2><strong>Custom Shirt</strong></h2></Navbar.Brand>
                        </>}
                        {(site !== 'customshirt.vn') && <>
                            <Navbar.Brand href="/login"><img src="./static/logo/logoshirt.webp" alt={site} style={{ width: "90px" }} /></Navbar.Brand>
                        </>}
                    </>
                }


                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">

                        {auth.user && <>

                            {sysMenu.map((m, idx) => {
                                return (
                                    m.menu_type === 1 ?
                                        <NavDropdown title={m.menu_name} key={m.menu_id} id={m.menu_id} style={{ paddingInline: "25px", fontSize: "14px" }}>
                                            {m.sub_menu.map((sm) => (
                                                sm.menu_type === 2 ?
                                                    <NavDropdown.Item href={sm.menu_link} key={sm.menu_id}><i className="bi bi-bag-check"></i> {sm.menu_name} </NavDropdown.Item>
                                                    :
                                                    <NavDropdown.Divider key={sm.menu_id} />
                                            ))}
                                        </NavDropdown>
                                        : <Nav.Link href={m.menu_link} key={m.menu_id} style={{ paddingInline: "25px", whiteSpace: 'nowrap', fontSize: "14px" }}> {m.menu_name}</Nav.Link>
                                )
                            })}

                        </>}
                        {/* 
                        <Nav.Link href="/about" style={{ whiteSpace: 'nowrap' }}> Contact us</Nav.Link> */}
                    </Nav>
                    <Navbar.Toggle />


                    <Navbar.Collapse className="justify-content-end">
                        <Nav.Link href="https://shirt.vn/upload/cdn/files/COMPANY%20PROFILE%20-%20SHIRTBYHAND%20(VIETNAM)%20PRODUCTION%20CO_%2C%20LTD.pdf">
                            OUR  FACTORY</Nav.Link>
                        {auth.user ? <>



                            <Avatar alt={auth.user.usr_name} src={`${auth.user['avatar']}`} />&nbsp;
                            <a href="/profile">{auth.user.usr_name}</a> /&nbsp;

                            <Nav.Link onClick={() => auth.logOut()} style={{ whiteSpace: 'nowrap' }}> Logout</Nav.Link>
                        </> : <>
                            {/* <Nav.Link href="/login"> Login</Nav.Link> */}
                        </>
                        }
                    </Navbar.Collapse>
                </Navbar.Collapse>

            </Container>


        </Navbar >
        <hr style={{ marginTop: "0px" }} />
    </>
    );
}

export default MainNavbar;
